import { routeConstants } from "services/keyConstants";

const baseUrl = `/${routeConstants.CONTROL_OF_NON_CONFIRMING}`;

export const CREATE = `${baseUrl}/`;

export const GET_BY_ID = `${baseUrl}/`;

export const UPDATE_SPECIFIC_DATA = `${baseUrl}/update-specific-data`;

export const DOWNLOAD = `${baseUrl}/download`;

export const GET_FILTERED_DOCS = `${baseUrl}/get-filtered-docs`;

export const GET_CHART_DATA = `${baseUrl}/get-chart-data`;

export const UPDATE_REGISTER = `${baseUrl}/update-register`;